module.exports = __webpack_public_path__ + "static/media/drag_indicator.f582b996.svg";